import { AppConfigFields } from "../types/appConfigEntities";
import { userStorage } from "./storage";

export const isMouchiSpecialCustomer = (): boolean =>
    userStorage.isMouchiSpecialCustomer?.() === true;

export const getMinimumPurchaseQuantity = (): number => {
    if (isMouchiSpecialCustomer()) return 1;
    return window.APP_CONFIG?.[AppConfigFields.MinimumPurchaseQuantity] ?? 1;
};

export const getMinimumPurchaseAmount = (): number => {
    if (isMouchiSpecialCustomer()) return 0;
    return window.APP_CONFIG?.[AppConfigFields.MinimumPurchaseAmount] ?? 0;
};
